const logAtLevel = level => {

    if (process.env.REACT_APP_LOG_LEVEL === 'trace')
        return true;
    
    if (process.env.REACT_APP_LOG_LEVEL === 'debug')
        return  level === 'debug' ||
                level === 'info' ||
                level === 'warn' ||
                level === 'severe' ||
                level === 'error';  
    
    if (process.env.REACT_APP_LOG_LEVEL === 'info')
        return  level === 'info' ||
                level === 'warn' ||
                level === 'severe' ||
                level === 'error';  
    
    if (process.env.REACT_APP_LOG_LEVEL === 'warn')
        return  level === 'warn' ||
                level === 'severe' ||
                level === 'error';    
    
    if (process.env.REACT_APP_LOG_LEVEL === 'severe')
        return  level === 'severe' ||
                level === 'error';  
    
    if (process.env.REACT_APP_LOG_LEVEL === 'error')
        return  level === 'error'; 
}

export const log = {
    trace: (msg, ...optionalParams) => { if (logAtLevel('trace'))  console.log(msg, ...optionalParams); },
    debug: (msg, ...optionalParams) => { if (logAtLevel('debug'))  console.log(msg, ...optionalParams); },
    info: (msg, ...optionalParams) => { if (logAtLevel('info'))  console.log(msg, ...optionalParams); },
    warn: (msg, ...optionalParams) => { if (logAtLevel('warn'))  console.log(msg, ...optionalParams); },
    severe: (msg, ...optionalParams) => { if (logAtLevel('severe'))  console.log(msg, ...optionalParams); },
    error: (msg, ...optionalParams) => { if (logAtLevel('error'))  console.error(msg, ...optionalParams); }
}